import { create } from 'zustand';
import { IOAuthStore } from './types';
import { oauthApi } from '@/API';
import { convertKeys } from '@/utils/common';

export const useOAuth = create<IOAuthStore>((set) => ({
  oAuthConnections: [],

  setOAuthConnections: (oAuthConnections) => set({ oAuthConnections }),
  connectOAuth: async (provider, connectionId) => {
    try {
      const response = await oauthApi.connectOAuthCalendar(
        provider,
        connectionId,
      );
      return convertKeys(response.data.data);
    } catch (error) {
      console.error('Failed to initiate OAuth connection:', error);
    }
  },
  loginWithOAuth: async (provider) => {
    try {
      const response = await oauthApi.ssoLogin(provider);
      return convertKeys(response.data.data);
    } catch (error) {
      console.error('Failed to initiate OAuth login:', error);
    }
  },
  deleteOAuthConnection: async (connectionId) => {
    try {
      await oauthApi.deleteOAuthConnection(connectionId);

      set(({ oAuthConnections }) => ({
        oAuthConnections: oAuthConnections.filter(
          (oac) => oac.id !== connectionId,
        ),
      }));
    } catch (error) {
      console.error('Failed to initiate OAuth connection:', error);
    }
  },
}));

export * from './types';
